import { ANPREvent } from 'domain/anpr-event'

export const emptyANPREvent: ANPREvent = {
  id: '',
  clientId: '',
  eventName: '',
  eventDescription: '',
  licensePlate: '',
  direction: '',
  cameraName: '',
  vehicleType: '',
  vehicleColor: '',
  speed: 0,
  cameraSpeedLimit: 0,
  licensePlateImagePath: '',
  detectionImagePath: '',
  createdDate: '',
  illegalCode: null,
  illegalName: null,
  illegalDescription: null,
  confidenceLevel: null,
}

export const vehicleColors = [
  { label: 'Branco', value: 'white' },
  { label: 'Preto', value: 'black' },
  { label: 'Prata', value: 'silver' },
  { label: 'Azul', value: 'blue' },
  { label: 'Vermelho', value: 'red' },
  { label: 'Verde', value: 'green' },
  { label: 'Amarelo', value: 'yellow' },
  { label: 'Cinza', value: 'gray' },
  { label: 'Marrom', value: 'brown' },
]

export const vehicleTypes = [
  { label: 'Carros', value: 'cars' },
  { label: 'Motos', value: 'bikes' },
  { label: 'Caminhões', value: 'trucks' },
  { label: 'Ônibus', value: 'buses' },
  { label: 'Pesssoas', value: 'people' },
]
